// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f143b55b","239":"7679e77d","453":"3bcbcd1b","455":"2cfed671"}[chunkId] + ".chunk.js";
};